import Resources from '../../helpers/resources';
import { handleResourceSuccess, handleResourceError } from '../../helpers/resource-handlers';

export const STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED = 'STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED';
export const STUDENT_CERTIFICATES_GEM_COUNT_SELECTED = 'STUDENT_CERTIFICATES_GEM_COUNT_SELECTED';

async function getStudentCertificatesGemCount({
    startDate,
    endDate,
    classroomId,
    groupId,
    studentUserProfileId,
    certificateType
}) {
    return dispatch => Resources
        .studentCertificatesGemCount
        .get()
        .withParams({ type: certificateType, startDate, endDate, classroomId, groupId, studentUserProfileId })
        .send()
        .then(
            payload => handleResourceSuccess(dispatch, payload, {
                type: STUDENT_CERTIFICATES_GEM_COUNT_RETRIEVED,
                payload: {
                    retrievedGems: payload.data
                }
            }),
            error => handleResourceError(dispatch, error)
        );
}

function downloadCertificatesByGem({ payload }) {
    return (dispatch) => {
        dispatch({
            type: STUDENT_CERTIFICATES_GEM_COUNT_SELECTED,
            payload
        });
    };
}

export default {
    getStudentCertificatesGemCount,
    downloadCertificatesByGem
};



// WEBPACK FOOTER //
// ./containers/certificates/student-certificates-gem-count-actions.js